import { faClose, faStopwatch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import {
  Ic_adulto,
  Ic_close,
  iconAdulto,
  iconNino,
} from "../../helpers/ImagesCache";
import useTranslation from "../../hooks/useTranslation";
import { FloatingDialog } from "../../components/atoms/FloatingDialog";
import { isTablet } from "react-device-detect";

const DialogPediatrico = ({
  icon,
  text,
  callbackConfirm,
  callbackCancel,
  status,
}) => {
  const T = useTranslation();
  const [isOpen, setIsOpen] = useState(status);
  const handlerClose = () => {
    if (callbackCancel) {
      callbackCancel();
    }
  };

  const handlerOnConfirm = () => {
    if (callbackConfirm) {
      callbackConfirm();
    }
  };

  useEffect(() => {
    setIsOpen(status);
  }, [status]);

  return (
    <>
      <FloatingDialog isOpen={isOpen} onClose={handlerClose}>
        <div className="flex p-10  flex-col w-full h-full items-center justify-center gap-5">
          <h3 className="font-bold text-center">{T(text)}</h3>
          <div className="flex gap-4">
            <button
              className={`gap-5 shadow  shadow-[#2AAC9C99]  ${isTablet? ' w-[150px] h-[150px]':' w-[110px] h-[110px]'} flex flex-col justify-center items-center border-1 border border-[#00055]  hover:text-white hover:bg-[#2aac9c]  text-black text-sm font-bold bg-[#fff]  rounded-[16px] p-4 `}
              onClick={handlerClose}
            >
              <span>Pediátrico</span>
              <div className=" bg-[#FEEFF2] rounded-[8px] p-[4px] w-[48px] h-[48px]">
                <img src={iconNino} alt={iconNino} />
              </div>
            </button>
            <button
              className={`gap-5 flex flex-col justify-center  shadow  shadow-[#2AAC9C99] ${isTablet? ' w-[150px] h-[150px]':' w-[110px] h-[110px]'} items-center  hover:text-white hover:bg-[#2aac9c] border-1 border border-[#00055] text-black text-sm font-bold bg-[#fff]  rounded rounded-[16px] p-4`}
              onClick={handlerOnConfirm}
            >
              <span>Adulto</span>
              <div className=" bg-[#FEEFF2] rounded-[8px] p-[4px] w-[48px] h-[48px]">
                <img src={Ic_adulto} alt={iconAdulto} />
              </div>
            </button>
          </div>
        </div>
      </FloatingDialog>
    </>
  );
};

export default DialogPediatrico;
